import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import AU from '../assets/AU.png'
import NLP from '../assets/NLP.png'
import PA from '../assets/PA.png'

export default function AIAgentCards() {
  const cardsData = [
    {
      image: AU,
      heading: 'Intelligent Automation',
      paragraph: 'AI agents automate complex tasks with human-like decision-making capabilities. They learn from interactions and continuously improve performance, reducing operational costs while increasing efficiency across your organization.'
    },
    {
      image: NLP,
      heading: 'Natural Language Processing',
      paragraph: 'Our AI agents understand and respond to human language naturally. They can handle customer inquiries, process documents, and communicate effectively in multiple languages, providing seamless user experiences 24/7.'
    },
    {
      image: PA,
      heading: 'Predictive Analytics',
      paragraph: 'Leverage AI agents to analyze patterns and predict future trends. Make data-driven decisions with confidence as our agents process vast amounts of information to provide actionable insights for your business growth.'
    }
  ];

  return (
    <div className="container my-5 py-5">
      {/* Main Heading */}
      <h2 
        className="text-center mb-5"
        style={{
        
          fontWeight: '700',
          color: '#333',
          marginBottom: '60px'
        }}
      >
        AI Agent Solutions
      </h2>

      {/* Cards Row */}
      <div className="row g-4">
        {cardsData.map((card, index) => (
          <div key={index} className="col-lg-4 col-md-6 col-sm-12">
            <div 
              className="card h-100"
              style={{
                border: 'none',
                backgroundColor: '#fff',
                borderRadius: '15px',
                overflow: 'hidden',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-10px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(106, 29, 194, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
              }}
            >
              <img 
                src={card.image} 
                className="card-img-top" 
                alt={card.heading}
                style={{
                  height: '250px',
                  objectFit: 'cover'
                }}
              />
              <div className="card-body p-4">
                <h5 
                  className="card-title"
                  style={{
                    fontSize: '1.5rem',
                    fontWeight: '700',
                    color: '#333',
                    marginBottom: '15px'
                  }}
                >
                  {card.heading}
                </h5>
                <p 
                  className="card-text"
                  style={{
                    fontSize: '1rem',
                    color: '#666',
                    lineHeight: '1.7'
                  }}
                >
                  {card.paragraph}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}